import _ from "lodash";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";

import { asDragSource } from "../../components/dragAndDrop/DraggableComponent";
import { DragDropTypes } from "../../constants/dragDropTypes";
import { TABLE_VIEW_HEADER } from "../../constants/identifiers";
import outlineColumnIds from "../../constants/outlineColumnIds";
// import { PropTypeShapes } from "../../types";
import hasAncestorOfClass from "../../utils/hasAncestorOfClass";
import { getScreenPointerPositionFromEvent } from "../../utils/mouseUtils";
import Icon from "../interface/Icon";

const clickWasResizer = e => hasAncestorOfClass(e.target, "tableHeaderColumnResizeHandle");

const dragCallbacks = {
  beginDrag: _props => {
    // TODO: Do we want to set isDragging or similar...?
  },

  canDrag: (props, dragSource, e) => {
    return props.canDrag && !clickWasResizer(e);
  },

  getDragSourceParams: props => {
    return {
      itemId: props.id,
      itemType: DragDropTypes.TABLE_COLUMN,
      sourceView: props.viewId,
      sourceViewType: TABLE_VIEW_HEADER
    };
  },

  getPreviewElement: props => renderItemPreview(props)
};

const renderItemPreview = itemProps => {
  const cloneProps = _.clone(itemProps);
  cloneProps.canResize = false;
  cloneProps.showColumnSelector = false;
  cloneProps.isDragPreview = true;
  return renderItem(cloneProps, null);
};

const renderItem = (useProps, onResizeMouseDown) => {
  const colStyle = {
    width: useProps.width + "px",
    flex: `0 0 ${useProps.width}px`
  };

  const resizeHandleClass = "tableHeaderColumnResizeHandle";

  const onClick = e => {
    const { onClick, id } = useProps;
    const clickTargetClassName = e.target.className;
    clickTargetClassName !== resizeHandleClass && onClick ? onClick(id) : null;
  };

  const sortLabel = `${useProps.isSorted ? "Sorted by" : "Sort by"} ${
    useProps.id === outlineColumnIds.sequence ? "Chronological Order. Allows row reordering." : useProps.label
  }`;
  const showTitle = useProps.isSorted || useProps.onClick;

  return (
    <div
      className={`tableHeaderColumn ${useProps.isDragging ? "hideDragSource" : ""} ${
        useProps.isSorted ? "isSorted" : ""
      } ${useProps.isDragPreview ? "dragPreview" : ""}`}
      style={colStyle}
      onClick={onClick}
      title={showTitle ? sortLabel : null}
    >
      <span>{useProps.label}</span>
      {useProps.isSorted ? <Icon icon={useProps.sortInDesc ? "upSolidArrow" : "downSolidArrow"} /> : null}
      {useProps.canResize ? <div className={resizeHandleClass} onMouseDown={onResizeMouseDown} /> : null}
    </div>
  );
};

class TableHeaderCellView extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.onResizeMouseDown = this.onResizeMouseDown.bind(this);
    this.onResizeMouseMove = this.onResizeMouseMove.bind(this);
    this.onResizeMouseUp = this.onResizeMouseUp.bind(this);
    this._mouseDownX = 0;
    this._mouseDownWidth = 0;
  }

  onResizeMouseDown(e) {
    document.addEventListener("mousemove", this.onResizeMouseMove);
    document.addEventListener("mouseup", this.onResizeMouseUp);
    document.addEventListener("touchmove", this.onResizeMouseMove);
    document.addEventListener("touchend", this.onResizeMouseUp);
    this._mouseDownX = getScreenPointerPositionFromEvent(e).x;
    this._mouseDownWidth = this.props.width;
  }

  onResizeMouseMove(e) {
    const x = getScreenPointerPositionFromEvent(e).x;
    const dist = x - this._mouseDownX;
    const width = this._mouseDownWidth + dist;
    if (this.props.canResize && this.props.onResize) {
      this.props.onResize(width);
    }
  }

  onResizeMouseUp() {
    document.removeEventListener("mousemove", this.onResizeMouseMove);
    document.removeEventListener("mouseup", this.onResizeMouseUp);
    document.removeEventListener("touchmove", this.onResizeMouseMove);
    document.removeEventListener("touchend", this.onResizeMouseUp);
    this._mouseDownX = 0;
  }

  render() {
    return renderItem(this.props, this.onResizeMouseDown);
  }
}

TableHeaderCellView.propTypes = {
  viewId: PropTypes.string.isRequired,
  tableId: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  canResize: PropTypes.bool,
  canDrag: PropTypes.bool,
  onResize: PropTypes.func,

  // Sorting
  isSorted: PropTypes.bool,
  sortInDesc: PropTypes.bool,
  onClick: PropTypes.func,

  // From asDragSource
  isDragging: PropTypes.bool,
  dragIsFromSameSource: PropTypes.bool
};

export default asDragSource(TableHeaderCellView, TABLE_VIEW_HEADER, dragCallbacks);
